import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Axios from "axios";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import { url } from "../../../Config/Config";
import { useStyles } from "./Dashboard.css";
import AdminHeader from "../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import DashboardCard from "./DashboardCard/DashboardCard";
import DashboardStudentChart from "./DashboardStudentChart/DashboardStudentChart";
import DashboardNoticeCard from "./DashboardNoticeCard/DashboardNoticeCard";
import DashboardAttendance from "./DashboardAttendance/DashboardAttendance";
import DashboardQuickLinks from "./DashboardQuickLinks/DashboardQuickLinks";
import DashboardBirthday from "./DashboardBirthday/DashboardBirthday";

import ClassIcon from "../../../Assets/Logo/ClassIcon.svg";
import EmployeesIcon from "../../../Assets/Logo/EmployeesIcon.svg";
import StudentIcon from "../../../Assets/Logo/StudentIcon.svg";
import BookIcon from "../../../Assets/Logo/BookIcon.svg";
import FeeIcon from "../../../Assets/Logo/FeeIcon.svg";
import DashboardLibrary from "./DashboardLibrary/DashboardLibrary";
import DashboardFees from "./DashboardFees/DashboardFees";
import { getAdminRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          label: "Total Number of Students",
          count: "",
          url: "/administration/students",
          role: ["Admin"],
          icon: (
            <img
              src={StudentIcon}
              alt="Classes"
              style={{ width: 50, height: 50 }}
            />
          ),
        },
        {
          label: "Total Number of Staffs",
          count: "",
          url: "/administration/staffs",
          role: ["Admin"],
          icon: (
            <img
              src={EmployeesIcon}
              alt="Classes"
              style={{ width: 50, height: 50 }}
            />
          ),
        },
        {
          label: "Total Number of Classes",
          count: "",
          url: "/administration/class",
          role: ["Admin"],
          icon: (
            <img
              src={ClassIcon}
              alt="Classes"
              style={{ width: 50, height: 50 }}
            />
          ),
        },
        {
          label: "Library Books Available",
          count: "",
          url: "/administration/library",
          role: ["Admin", "Librarian"],
          icon: (
            <img src={BookIcon} alt="Book" style={{ width: 50, height: 50 }} />
          ),
        },
        {
          label: "Total Fees Types",
          count: "",
          url: "/administration/Fees-Type",
          role: ["Admin", "Accountant"],
          icon: (
            <img src={FeeIcon} alt="Fee" style={{ width: 50, height: 50 }} />
          ),
        },
        {
          label: "Total Fees Groups",
          count: "",
          url: "/administration/Fees-Group",
          role: ["Admin", "Accountant"],
          icon: (
            <img src={FeeIcon} alt="Fee" style={{ width: 50, height: 50 }} />
          ),
        },
      ],
      studentList: [],
      staffList: [],
      classList: [],
      bookList: [],
    };
  }

  componentDidMount() {
    this.dashboardCount();
  }

  dashboardCount = async () => {
    try {
      if (
        this.props.role === "admin" ||
        this.props.role === "Accountant" ||
        this.props.role === "Librarian"
      ) {
        const studentResponse = await Axios.get(`${url}/api/students`, {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        });
        this.setCount(
          "Total Number of Students",
          studentResponse.data.students.length
        );
        this.setState({ studentList: studentResponse.data.students });

        const classResponse = await Axios.get(`${url}/api/schoolclass`, {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        });
        this.setState({ classList: classResponse.data.classes });
        this.setCount(
          "Total Number of Classes",
          classResponse.data.classes.length
        );
      }

      if (this.props.role === "admin") {
        const staffResponse = await Axios.get(`${url}/api/staffs`, {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        });
        this.setCount(
          "Total Number of Staffs",
          staffResponse.data.staffs.length
        );
        this.setState({ staffList: staffResponse.data.staffs });
      }

      if (this.props.role === "admin" || this.props.role === "Librarian") {
        const response = await Axios.get(`${url}/api/books`, {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        });
        this.setCount("Library Books Available", response.data.books.length);
        if (response.data.books.length !== 0) {
          this.setState({ bookList: response.data.books, isEmpty: false });
        } else {
          this.setState({ bookList: [], isEmpty: true });
        }
      }

      if (this.props.role === "admin" || this.props.role === "Accountant") {
        const feeTypeResponse = await Axios.get(`${url}/api/fee-types`, {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        });
        this.setCount("Total Fees Types", feeTypeResponse.data.feesType.length);
        const groupResponse = await Axios.get(`${url}/api/fee-groups`, {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        });
        this.setCount(
          "Total Fees Groups",
          groupResponse.data.feesGroups.length
        );
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.dashboardCount();
      }
    }
  };

  setCount = (label, tempCount) => {
    let newArray;
    newArray = this.state.data.map((data) =>
      data.label === label
        ? { ...data, count: tempCount }
        : { ...data, count: data.count }
    );
    this.setState({
      data: newArray,
    });
  };

  render() {
    const { classes } = this.props;
    let accountCards = this.state.data.filter((filter) =>
      filter.role.includes("Accountant")
    );
    let libraryCards = this.state.data.filter((filter) =>
      filter.role.includes("Librarian")
    );
    let cards =
      this.props.role === "admin"
        ? this.state.data
        : this.props.role === "Accountant"
        ? accountCards
        : this.props.role === "Librarian" && libraryCards;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <PageTitle title="Dashboard" refreshUrl={this.props.match.url} />

          <Grid container spacing={3}>
            {cards.map((data, index) => (
              <DashboardCard
                key={index}
                url={data.url}
                label={data.label}
                count={data.count}
                icon={data.icon}
              />
            ))}
          </Grid>
          <Grid container spacing={3}>
            {this.props.role === "admin" && (
              <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                <DashboardStudentChart
                  studentList={this.state.studentList}
                  classList={this.state.classList}
                />
              </Grid>
            )}

            {this.props.role === "admin" && (
              <Grid
                item
                container
                spacing={3}
                xs={12}
                sm={12}
                md={12}
                xl={12}
                lg={12}
              >
                <DashboardAttendance />
              </Grid>
            )}

            {this.props.role === "admin" && (
              <Grid
                item
                container
                spacing={3}
                xs={12}
                sm={12}
                md={12}
                xl={12}
                lg={12}
              >
                <DashboardNoticeCard />
                <DashboardBirthday
                  studentList={this.state.studentList}
                  staffList={this.state.staffList}
                />
              </Grid>
            )}
          </Grid>
          <br />
          {(this.props.role === "Accountant" ||
            this.props.role === "admin") && (
            <DashboardFees totalStudents={this.state.studentList.length} />
          )}
          <br />

          {(this.props.role === "Librarian" || this.props.role === "admin") && (
            <DashboardLibrary bookList={this.state.bookList} />
          )}
          <br />
          {this.props.role === "admin" && <DashboardQuickLinks />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(Dashboard)));
